export function getFormattingLanguage(controllerConfig) {
  return getMLLocale(controllerConfig) || controllerConfig.wixCodeApi.site.regionalSettings || 'en-US';
}
function getMLLocale(controllerConfig) {
  const currentLang = getCurrentlyUsedMultilingualLanguage(controllerConfig);
  /* istanbul ignore else */
  if (!currentLang) {
    return undefined;
  }
  /* istanbul ignore next */
  return currentLang.locale || controllerConfig.wixCodeApi.window.multilingual.currentLanguage;
}

/* istanbul ignore next */
function getCurrentlyUsedMultilingualLanguage(controllerConfig) {
  const currentShortLang = controllerConfig.wixCodeApi.window.multilingual.currentLanguage;
  return controllerConfig.wixCodeApi.window.multilingual.siteLanguages.find(lang => lang.languageCode === currentShortLang);
}
//# sourceMappingURL=getFormattingLanguage.js.map